<template>
  <div class="intro_sm d-flex justify-content-center">
    <a
      href="https://www.facebook.com/sharer/sharer.php?u=https%3A//kochamwilki.pl/"
    >
      <img
        class="thanks__sm"
        src="@/assets/images/fb_icon.png"
        alt="Udostępnij na Facebooku"
    /></a>
    <a
      href="https://twitter.com/intent/tweet?text=Kochasz%20wilki?%20Nie%20chcesz,%20by%20do%20nich%20strzelano?%20Poka%C5%BC%20swoj%C4%85%20mi%C5%82o%C5%9B%C4%87%20na%20https%3A//kochamwilki.pl%20-%20stw%C3%B3rz%20walentynk%C4%99%20do%20wilka,%20a%20%40Greenpeace_PL%20przeka%C5%BCe%20je%20do%20Ministerstwa%20Klimatu%20i%20%C5%9Arodowiska"
    >
      <img
        class="thanks__sm"
        src="@/assets/images/x_icon.png"
        alt="Udostępnij na Twitterze"
    /></a>
    <a
      href="https://wa.me/1234?text=Kochasz%20wilki%3F%20Nie%20chcesz%2C%20by%20do%20nich%20strzelano%3F%20Poka%C5%BC%20swoj%C4%85%20mi%C5%82o%C5%9B%C4%87%20na%20https%3A%2F%2Fkochamwilki.pl%20-%20stw%C3%B3rz%20walentynk%C4%99%20do%20wilka%2C%20a%20Greenpeace%20przeka%C5%BCe%20je%20do%20Ministerstwa%20Klimatu%20i%20%C5%9Arodowiska"
    >
      <img
        class="thanks__sm"
        src="@/assets/images/w_icon.png"
        alt="Udostępnij na Whatsappie"
    /></a>
  </div>
</template>
<script>
export default {
  name: "ShareLinks",
  data() {
    return {
      title: "Share links",
    };
  },
};
</script>
